/**
 * Changing a user's email locks them out of their account, so the field is
 * presented read-only while editing. Creating a user still takes an email as
 * usual.
 *
 * Shared by the Provider User and Staff User forms, which is why it sits here
 * rather than in either form's own schema file.
 */
export const EMAIL_LOCKED_HELPER_TEXT =
  "Email cannot be changed here. Contact support to update.";
